import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar'
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'
import DestinationCc from '../../components/DestinationCherdchai';
import SearchSectionCC from '../../components/SearchSectionCherdchai';

const Cherdchai =() => {
    return(
        <Fragment>
            <Navbar/>
            <SearchSectionCC/>
            <DestinationCc/>
            <Footer/> 
            <Scrollbar/>
        </Fragment>
    )
};
export default Cherdchai;